export const countryMap = {
  NG: "Nigeria",
  US: "United states of America",
};

export const countryCurrencyMap = {
  NG: "NGN",
  KE: "KES",
};
